import React from 'react'
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useCloseJournalReconPeriodMutation } from '../../../../api-services/financial/journalReconApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import ButtonLoadingComponent from '../../../../views/components/shared/ButtonLoadingComponent'

interface Props {
  startDate: string
  onCloseDialog: () => void
  onSuccess: () => void
}

const CloseJournalReconPeriodDialog: React.FC<Props> = ({ startDate, onCloseDialog, onSuccess }) => {
  const dispatch = useAppDispatch()
  const [apiClosePeriod, { isLoading }] = useCloseJournalReconPeriodMutation()

  const handleClose = (): void => {
    apiClosePeriod(startDate)
      .unwrap()
      .then(() => {
        dispatch(setNotification({ open: true, severity: 'success', message: `Period ${startDate} closed.` }))
        onSuccess()
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  return (
    <Dialog
      open={true}
      maxWidth={'sm'}
      fullWidth={true}
      onClose={() => { onCloseDialog() }}
    >
      <DialogTitle>Close Journal Period</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant={'body1'} sx={{ mb: 2 }}>
            You are about to close the period <strong>{startDate}</strong>.
          </Typography>
          <Typography variant={'body2'} sx={{ mb: 2 }}>
            All journals for this period will be marked processed, your email address will be recorded
            against each one, and the CSV exports will be unlocked. This cannot be reversed from the UI.
          </Typography>
        </Box>

        <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
          <Button variant={'contained'} color={'primary'} onClick={handleClose} disabled={isLoading}>
            Close Period
            { isLoading && <ButtonLoadingComponent /> }
          </Button>
          <Button variant={'outlined'} onClick={() => { onCloseDialog() }} disabled={isLoading}>
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default CloseJournalReconPeriodDialog
